export const messages = {
  en: {
    servAppraiseManage: {
      queryTitle: 'Query Conditions',
      servNamePlaceholder: 'Service Name',
      userPlaceholder: 'User Name',
      servIdPlaceholder: 'Service ID',
      queryBtn: 'Search',
      resetBtn: 'Reset',
      tableTitle: 'Service Appraise',
      addBtn: 'Add Appraise',
      addTitle: 'Add Appraise',
      editTitle: 'Edit Appraise',
      deleteConfirm: 'Are you sure to delete this appraise?',
      table: {
        servName: 'Service Name',
        appraiseUserName: 'User',
        appraiseScore: 'Score',
        context: 'Content',
        imgPath: 'Images',
        createTime: 'Create Time',
        operation: 'Operation',
        replyBtn: 'Reply',
        editBtn: 'Edit',
        deleteBtn: 'Delete'
      },
      form: {
        servName: 'Service Name',
        servNameRequired: 'Please enter service name',
        userName: 'User Name',
        userNameRequired: 'Please enter user name',
        score: 'Score',
        scoreRequired: 'Please select score',
        context: 'Content',
        contextRequired: 'Please enter content',
        images: 'Images'
      }
    }
  },
  zh: {
    servAppraiseManage: {
      queryTitle: '查询条件',
      servNamePlaceholder: '服务名称',
      userPlaceholder: '请输入用户',
      servIdPlaceholder: '请输入服务编号',
      queryBtn: '查询',
      resetBtn: '重置',
      tableTitle: '服务评论',
      addBtn: '新增评价',
      addTitle: '新增评价',
      editTitle: '编辑评价',
      deleteConfirm: '确认删除该评价吗？',
      table: {
        servName: '服务名称',
        appraiseUserName: '用户',
        appraiseScore: '评分',
        context: '内容',
        imgPath: '图片',
        createTime: '评论时间',
        operation: '操作',
        replyBtn: '回复',
        editBtn: '编辑',
        deleteBtn: '删除'
      },
      form: {
        servName: '服务名称',
        servNameRequired: '请输入服务名称',
        userName: '用户名',
        userNameRequired: '请输入用户名',
        score: '评分',
        scoreRequired: '请选择评分',
        context: '评价内容',
        contextRequired: '请输入评价内容',
        images: '评价图片'
      }
    }
  }
}
